import React, { useState } from "react";
import axios from "axios";

const App = () => {
  const [formType, setFormType] = useState("");
  const [name, setName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nameRegex = /^[A-Za-z\s]+$/;
    const phoneRegex1 = /^[0-9]+$/;
    const phoneRegex = {
      "+1": /^\d{10}$/, // USA: 10 digits
      "+44": /^\d{10,11}$/, // UK: 10 or 11 digits
      "+91": /^\d{10}$/, // India: 10 digits
      "+61": /^\d{9,10}$/, // Australia: 9 or 10 digits
      "+86": /^\d{11}$/, // China: 11 digits
      "+49": /^\d{10,11}$/, // Germany: 10 or 11 digits
      "+33": /^\d{9,10}$/, // France: 9 or 10 digits
      "+81": /^\d{10,11}$/, // Japan: 10 or 11 digits
      "+7": /^\d{10,11}$/, // Russia: 10 or 11 digits
      "+55": /^\d{10}$/, // Brazil: 10 digits
      "+92": /^\d{10}$/, // Pakistan: 10 digits
      "+234": /^\d{10}$/, // Nigeria: 10 digits
    };

    if (!name.match(nameRegex)) {
      alert("Name must contain only alphabetic characters.");
      return;
    }
    if (!phoneNumber.match(phoneRegex1)) {
      alert("Phone number must contain only numeric characters.");
      return;
    }

    if (!countryCode) {
      alert("Please select a country code.");
      return;
    }
    const selectedPhoneRegex = phoneRegex[countryCode];
    if (!selectedPhoneRegex) {
      alert("Please select a valid country code.");
      return;
    }

    if (!phoneNumber.match(selectedPhoneRegex)) {
      alert("Phone number format is incorrect for selected country code.");
      return;
    }

    try {
      // eslint-disable-next-line
      const response = await axios.post("http://localhost:5000/submit", {
        formType,
        name,
        countryCode,
        phoneNumber,
      });
      alert("Form data submitted successfully");
      setFormType("");
      setName("");
      setCountryCode("");
      setPhoneNumber("");
    } catch (err) {
      console.error(
        "Error submitting form data:",
        err.response ? err.response.data : err.message
      );
      alert("Error submitting form data");
    }
  };

  const handleRefresh = async () => {
    try {
      // eslint-disable-next-line
      const response = await axios.post("http://localhost:5000/refresh-excel");
      alert("Google Sheet refreshed successfully");
    } catch (err) {
      console.error(
        "Error refreshing Google Sheet:",
        err.response ? err.response.data : err.message
      );
      alert("Failed to refresh Google Sheet");
    }
  };

  return (
    <div className='flex flex-col items-center justify-center min-h-screen bg-blue-400'>
      <div className='mb-4 flex flex-wrap justify-center'>
        <button
          className='mx-2 my-1 px-4 py-2 bg-yellow-300 text-white rounded'
          onClick={() => setFormType("A")}
        >
          Form A
        </button>
        <button
          className='mx-2 my-1 px-4 py-2 bg-yellow-300 text-white rounded'
          onClick={() => setFormType("B")}
        >
          Form B
        </button>
        <button
          className='mx-2 my-1 px-4 py-2 bg-pink-500 text-white rounded'
          onClick={handleRefresh}
        >
          Refresh Google Sheet
        </button>
      </div>
      {formType && (
        <form
          onSubmit={handleSubmit}
          className='w-full max-w-md mx-auto bg-white p-6 rounded-lg shadow-lg'
        >
          <h2 className='text-3xl font-bold underline mb-4'>{`Form ${formType}`}</h2>
          <div className='mb-4'>
            <input
              type='text'
              placeholder='Name'
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className='w-full px-3 py-2 border rounded'
            />
          </div>
          <div className='mb-4'>
            <select
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
              required
              className='w-full px-3 py-2 border rounded'
            >
              <option value=''>Select Country Code</option>
              <option value='+1'>+1 (USA)</option>
              <option value='+44'>+44 (UK)</option>
              <option value='+91'>+91 (India)</option>
              <option value='+61'>+61 (Australia)</option>
              <option value='+86'>+86 (China)</option>
              <option value='+49'>+49 (Germany)</option>
              <option value='+33'>+33 (France)</option>
              <option value='+81'>+81 (Japan)</option>
              <option value='+7'>+7 (Russia)</option>
              <option value='+55'>+55 (Brazil)</option>
              <option value='+92'>+92 (Pakistan)</option>
              <option value='+234'>+234 (Nigeria)</option>
            </select>
          </div>
          <div className='mb-4'>
            <input
              type='text'
              placeholder='Phone Number'
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              className='w-full px-3 py-2 border rounded'
            />
          </div>
          <button
            type='submit'
            className='w-full px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600'
          >
            Submit
          </button>
        </form>
      )}
    </div>
  );
};

export default App;
